/**
 * The guarantee behind the whole error layer: text matching a technical
 * fingerprint is never shown to a user. The catalogue in classify.js can be
 * incomplete — this cannot be bypassed.
 *
 * Raw text still reaches Monitoring. It is stripped from the screen, not from
 * the record: see classifyApiError's `rawMessage`.
 *
 * Written the way it is because of a real toast on 2026-09-18, which read
 * "SERVER ERROR (500): CURL ERROR 7: FAILED TO CONNECT TO 3.10.208.169 PORT
 * 8080…" on the Orders page.
 */

const TECHNICAL =
  /cURL|SQLSTATE|Exception|Stack trace|Undefined |TypeError|::|\.php\b|https?:\/\/|\b\d{1,3}(\.\d{1,3}){3}\b|at line \d+|PDO|Fatal error/i;

// Anything longer than this is a dump, not a sentence, whatever it contains.
const MAX_LENGTH = 240;

export function looksTechnical(text) {
  if (typeof text !== "string") return true;

  const trimmed = text.trim();
  if (!trimmed) return true;
  if (trimmed.length > MAX_LENGTH) return true;

  return TECHNICAL.test(trimmed);
}

export function safeText(candidate, fallback) {
  if (looksTechnical(candidate)) return fallback;
  return candidate.trim().replace(/\s+/g, " ");
}
